import React, { Component } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import MyTextField from "./MyTextField";
import Button from "@mui/material/Button";

class RegisterForm extends Component {
  state = {
    NameFamily: "",
    CompanyName: "",
  };
  onSubmit = (e) => {
    e.preventDefault();
    if (!this.state.NameFamily) {
      alert("لطفا نام و نام خانوادگی خود را وارد نمایید");
      return;
    }
    this.props.handleRegister(this.state.NameFamily, this.state.CompanyName);
  };
  render() {
    return (
      <form className="add-form" onSubmit={this.onSubmit}>
        <Box sx={{ width: "100%" }}>
          <Stack
            sx={{ bottom: 30, right: 15, left: 15, position: "fixed" }}
            spacing={2}
          >
            <MyTextField
              label="نام و نام خانوادگی"
              type="text"
              onChange={(e) => this.setState({ NameFamily: e.target.value })}
            />
            <MyTextField
              label="نام شرکت"
              type="text"
              onChange={(e) => this.setState({ CompanyName: e.target.value })}
            />
            <Button type="submit" variant="contained">
              ذخیره
            </Button>
          </Stack>
        </Box>
      </form>
    );
  }
}

export default RegisterForm;
